var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poster"},[_c('vue-canvas-poster',{attrs:{"widthPixels":1000,"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.img,"width":"100%"}}),_vm._v(" "),_c('Floating')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec3c856","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/agency/share.vue
// module id = null
// module chunks = 